export default __webpack_public_path__ + "static/media/06__o_4.c2d52ab4.jpg";